export const APP_ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  AIRDROPS: "/airdrops",
  TOTAL_TRUST_SCORE: "/total-trust-score",
  PROMOTION: "/promotion",
  DEFAULT: "*",
} as const;
